<template>
  <div class="warehouse-doc">
    <small class="date"> {{ doc.place }}, {{ doc.creation_date | formatDate }} </small>
    <br />
    <h1>{{ subtype }}{{ doc.name }}</h1>
    <br />
    <div class="people-data">
      <div class="view-section">
        <h2>Dostawca</h2>
        <span>{{ doc.from.name }}</span>
        <small>{{ doc.from.address }}</small>
        <small>{{ doc.from.post_code }}, {{ doc.from.city }}</small>
        <small v-if="doc.from.vat">NIP: {{ doc.from.vat }}</small>
      </div>
      <div class="view-section">
        <h2>Odbiorca</h2>
        <span>{{ doc.to.name }}</span>
        <small>{{ doc.to.address }}</small>
        <small>{{ doc.to.post_code }}, {{ doc.to.city }}</small>
        <small v-if="doc.to.vat">NIP: {{ doc.to.vat }}</small>
      </div>
    </div>

    <div class="wh-doc">
      <div class="wh-doc__item wh-doc__item--header">
        <span>Symbol</span>
        <span>Nazwa</span>
        <span>Netto</span>
        <span>Ilość</span>
      </div>
      <div class="wh-doc__item" v-for="item in doc.details.items" :key="item.name">
        <span>{{ item.symbol }}</span>
        <span>{{ item.name }}</span>
        <span>{{ item.value | formatMoney('pln') }}</span>
        <span>{{ item.qty | formatQuantity }}</span>
      </div>
    </div>

    <div class="row">
      <div class="whd-details">
        <h2>Magazyn</h2>
        <span>{{ doc.details.warehouse.name || '---' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getWarehouseDocType } from '@/utils/warehouseDocType'

export default {
  name: 'app-warehouse-doc',
  computed: {
    doc() {
      return this.$store.state.docs.selectedDoc
    },
    subtype() {
      return getWarehouseDocType(this.doc.subtype)
    },
  },
}
</script>

<style lang="scss" scoped>
.document-view {
  @extend %flex;
  flex-direction: column;
  padding: 16px;

  .links {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    &--center {
      justify-content: center;
    }
  }

  .date {
    width: 100%;
    display: block;
    text-align: right;
  }

  .people-data {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;

    @media screen and (min-width: #{$media-900}) {
      flex-direction: row;
    }
  }

  .view-section {
    font-size: 1.1em;
    margin-top: 12px;
    width: 100%;

    > * {
      display: block;
    }
    span {
      font-weight: 500;
    }
    b {
      font-weight: 500;
    }
    h2 {
      text-align: left;
    }
  }

  .wh-doc {
    width: 100%;
    margin-top: 32px;

    &__item {
      display: grid;
      grid-template-columns: 0.3fr 1fr 0.3fr 0.3fr;

      > * {
        padding: 8px 4px;
      }

      &--header {
        font-weight: 300;
        font-size: 0.8em;
        color: #666;
        border-bottom: dashed 1px #666;

        > * {
          padding: 4px;
        }
      }
    }
  }

  .row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;

    @media screen and (min-width: #{$media-900}) {
      flex-direction: row;
    }
  }

  .whd-details {
    text-align: left;
    margin-top: 32px;
    width: 100%;

    h2 {
      text-align: left;
      margin-top: 4px;
    }
  }

  h2 {
    margin: 0;
    font-size: 0.6em;
    color: #333;
    font-weight: 400;
  }

  .flex {
    display: flex;

    .view-section {
      width: 50%;
    }
  }
}
</style>
